// extracted by mini-css-extract-plugin
export var container = "_4b-0";
export var error = "_4b-9";
export var label = "_4b-5";
export var light = "_4b-6";
export var md = "_4b-3";
export var sm = "_4b-2";
export var thin = "_4b-8";
export var thinBold = "_4b-7";
export var vertical = "_4b-4";
export var xs = "_4b-1";